import { Popover } from "antd";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import styles from "./index.module.less";
import { getExtractPersonInfo } from "@/api/llm";
import { SearchType } from "@/services/SearchService";
import ShareUserCard from "@/components/chat/message/share/UserCard";
import { generateMessageId } from "@jd/jdee.im.sdk/lib/es/utils/utils";
import ChatState from "@/types/chat/State";
import { connect } from "dvajs";
import IconFont from "@/components/icon";
import { FocusSDK } from "@/utils";
import { mapUserDataToUserCard } from "@/components/UserCard/common";
import config, { ChatConfig, ConfigEnum } from "@/config/config";
import { NetState } from "@/models/netStatus";
import { AVSDK } from "@/baseComponents/Meeting/common";
import { getEBookUserDetail } from "@/api/ebook";
import Loading from "@/components/Loading";
/**
 * 人员感知气泡
 */

function mapStateToProps({ chat, netStatus }: { chat: ChatState; netStatus: NetState }) {
  const { currentEmployee, selectedSession } = chat;
  return {
    currentEmployee,
    selectedSession,
    newPublicResult: netStatus.newPublicResult
  };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

function AiUserLink(props: any) {
  const { content, selectedSession, currentEmployee, newPublicResult } = props;
  const [loading, setLoading] = useState<boolean>(true);
  const [searchResult, setSearchResult] = useState<any>(null);

  const cardMsg = useMemo(() => {
    return {
      id: generateMessageId(),
      data: [
        {
          sharecard: searchResult
        }
      ]
    };
  }, [searchResult]);

  const emptyComp = useMemo(() => {
    return (
      <div className={styles["empty-wrap"]}>抱歉，未能找到匹配的人员。您可以尝试更精确的描述。</div>
    );
  }, []);

  // 加入会议
  const handleJoinMeeting = useCallback(
    async (e: any) => {
      e?.stopPropagation();
      try {
        const user: any = await getEBookUserDetail({
          userId: searchResult?.userId || searchResult?.pin,
          teamId: searchResult?.teamId,
          appId: searchResult?.appId || searchResult?.app,
          isMulti: false
        });
        if (user) {
          const avatar = user?.fields?.find((i: any) => i.key === "avatar");
          const name = user?.fields?.find((i: any) => i.key === "name");
          const from = {
            app: currentEmployee.app,
            teamId: currentEmployee.teamId,
            pin: currentEmployee.userId,
            avatar: currentEmployee.avatar,
            name: currentEmployee.name
          };
          const to = {
            pin: user.userId,
            teamId: user.teamId,
            app: user.appId,
            avatar: avatar?.val || "",
            name: name?.val || ""
          };
          if (config[ConfigEnum.CHAT_SESSION_CREATE_JD_VIDEO_ENABLE]) {
            FocusSDK.sendToMain("ai:mt:single:meeting:create", {
              from,
              to,
              avsdk: AVSDK.JBRTC,
              type: ""
            });
          } else {
            FocusSDK.sendToMain("ai:mt:group:meeting:create", {
              to: user,
              from: currentEmployee,
              netState: newPublicResult
            });
          }
        }
      } catch (e) { }
    },
    [currentEmployee, newPublicResult, searchResult]
  );

  // 打开会话
  const handleChat = useCallback(
    (e: any) => {
      e?.stopPropagation();
      const cardData = mapUserDataToUserCard(searchResult);
      const path = `/messages/s/${cardData.userId}?app=${cardData?.appId}&tid=${cardData.teamId}`;
      FocusSDK.launchNewSession(path);
    },
    [searchResult]
  );

  // 操作区
  const getCustomFooterNode = useMemo(() => {
    return (
      <div className="card-footer">
        {config[ChatConfig.CHAT_SESSION_CREATE_MEETING_ENABLE] && <div className="item" onClick={(e) => handleJoinMeeting(e)}>
          <IconFont className="icon" type="iconapp_btn_joymerting_video" />
          视频通话
        </div>}
        <div className="item" onClick={(e) => handleChat(e)}>
          <IconFont className="icon" type="iconic_chat" />
          发消息
        </div>
      </div>
    );
  }, [handleChat, handleJoinMeeting]);

  const popoverContent = useMemo(() => {
    return (
      <div className={styles["user-link-popover-container"]}>
        <div className={styles["title"]}>猜您想找:</div>
        {searchResult ? (
          <ShareUserCard
            message={cardMsg}
            sessionType={selectedSession.sessionId}
            showFooter={false}
            customFooter={getCustomFooterNode}
          />
        ) : !loading ? (
          emptyComp
        ) : (
          <div className={styles["empty-wrap"]}>
            <Loading />
          </div>
        )}
      </div>
    );
  }, [cardMsg, emptyComp, getCustomFooterNode, loading, searchResult, selectedSession.sessionId]);

  const handleVisibleChange = useCallback(
    (visible) => {
      if (visible && !searchResult) {
        setLoading(true);
        // 大搜
        getExtractPersonInfo({
          text: content
        })
          .then((res: any) => {
            if (res?.contacts?.length) {
              const contacts = res?.contacts[0];
              const data = {
                ...contacts,
                nickName: contacts.realName,
                pin: contacts.userId
              };
              setSearchResult(data);
            }
          })
          .finally(() => {
            setLoading(false);
          });
      }
    },
    [content, searchResult]
  );

  return (
    <span className={`${styles["user-link-box"]}`}>
      <Popover
        placement="topRight"
        content={popoverContent}
        overlayClassName={styles["user-link-popover"]}
        destroyTooltipOnHide={false}
        onVisibleChange={(e) => handleVisibleChange(e)}
      >
        <span
          className={`${styles["box-content"]}`}
          clstag="pageclick|keycount|Xtbg_Msg_SmartFindPerson_Popup"
        >
          <span className={styles["message-text-link"]}>{content}</span>
        </span>
      </Popover>
    </span>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(AiUserLink);
